import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { uuid } from "uuidv4";

import {
    store as generalSettingStore,
    setIsModified,
    setIsLoading,
    setKey,
} from "../store";
import { store } from "@components/VerticalLayout/store";
import { generalConfigStore, setItemsDisable } from "@store";

import { capitalize } from "@helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import ErrorToast from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { apiRequest, createDataLanguage, createLanguageItem } from "../hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationModifiedMessageType = {
    setModalState: Function;
    modalState: any;
    tableState: any;
};

export function ConfirmationAssociateModifiedMessage({
    setModalState,
    modalState,
    tableState,
}: ConfirmationModifiedMessageType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { franchiseID, userID, operatorID } = useSnapshot(store);
    const { isModified, isActivation, shopsLanguagesData } = useSnapshot(
        generalSettingStore
    );
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const uuidUser = localStorage.getItem("uuidUser");
    async function enableAllLanguage() {
        setIsLoading(true);
        toast.dismiss();
        const id = tableState.selectedElement.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            tableState.selectedElement.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            tableState.rowData.isActive,
            false,
            tableState.selectedElement.selectedRow.isFavorite
        );
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            ErrorToast(`${t("There's an error")}`);
        }
    }
    async function enableLocalLanguage() {
        setIsLoading(true);
        toast.dismiss();
        const id = tableState.selectedElement.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            tableState.selectedElement.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            tableState.rowData.isActive,
            false,
            tableState.selectedElement.selectedRow.isFavorite
        );
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            ErrorToast(`${t("There's an error")}`);
        }
    }
    async function favoriteShopLanguage(
        isFavorite: boolean,
        isValidation: any
    ) {
        toast.dismiss();
        setIsLoading(true);
        let shopIds: any = ["0"];
        if (isValidation) {
            shopsLanguagesData.forEach((shop: any) => {
                shop.subRows.forEach((language: any) => {
                    if (
                        tableState.selectedElement.selectedRow.Id ===
                        language.Id
                    ) {
                        if (!shopIds.includes(language.shopId.toString())) {
                            shopIds.push(language.shopId.toString());
                            tableState.objectData[
                                language.shopId.toString()
                            ] = {};
                        }
                        Object.assign(
                            tableState.objectData[language.shopId.toString()],
                            {
                                ...createLanguageItem(
                                    language,
                                    language.Id,
                                    true,
                                    language.isArchived,
                                    isFavorite,
                                    language.shopId
                                ),
                            }
                        );

                        if (language.isActive === false) {
                            const item = itemsDisable.filter(
                                (item: any) =>
                                    !(
                                        item.id === language.Id &&
                                        item.shopId === language.shopId
                                    )
                            );
                            setItemsDisable(item);
                        }
                    } else if (
                        shop.subRows.findIndex(
                            (elt: any) =>
                                elt.Id ===
                                tableState.selectedElement.selectedRow.Id
                        ) !== -1 &&
                        language.isFavorite === true
                    ) {
                        if (!shopIds.includes(language.shopId.toString())) {
                            shopIds.push(language.shopId.toString());
                            tableState.objectData[
                                language.shopId.toString()
                            ] = {};
                        }
                        Object.assign(
                            tableState.objectData[language.shopId.toString()],
                            {
                                ...createLanguageItem(
                                    language,
                                    language.Id,
                                    language.isActive,
                                    language.isArchived,
                                    false,
                                    language.shopId
                                ),
                            }
                        );
                    }
                });
            });
        }
        let dataLanguage = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: true,
            data: tableState.objectData,
            isMultiShop: true,
            updateFavorite: true,
        };

        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            setIsLoading(false);
            ShowSuccessToast(
                `${
                    isFavorite
                        ? `${t(
                              "Shop favorite state has been successfully activated"
                          )}`
                        : `${t(
                              "Shop favorite state has been successfully deactivated"
                          )}`
                }`
            );
            setKey(uuid());
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    }
    return (
        <StyledModal
            toggle={true}
            isOpen={modalState.isAssociateModified!}
            centered
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setModalState({
                        ...modalState,
                        isAssociateModified: false,
                    });
                    isActivation
                        ? enableLocalLanguage()
                        : favoriteShopLanguage(
                              !tableState.selectedElement.selectedRow
                                  .isFavorite,
                              false
                          );
                    setIsModified(!isModified);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setModalState({
                            ...modalState,
                            isAssociateModified: false,
                        });
                        isActivation
                            ? enableLocalLanguage()
                            : favoriteShopLanguage(
                                  !tableState.selectedElement.selectedRow
                                      .isFavorite,
                                  false
                              );
                        setIsModified(!isModified);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        isActivation
                            ? enableAllLanguage()
                            : favoriteShopLanguage(
                                  !tableState.selectedElement.selectedRow
                                      .isFavorite,
                                  true
                              );
                        setModalState({
                            ...modalState,
                            isAssociateModified: false,
                        });
                        setIsModified(!isModified);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
